export default "__VITE_ASSET__GVVQ0pwR__"